import brandPortalMyShopSettings from "@faire/web-api/routes/brand-portal/my-shop/settings";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var InternationalOrderSettings = function InternationalOrderSettings() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YKn+GK",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt op Faire kiezen waar je je producten wilt verkopen. Je kunt de verkoop in bepaalde regio’s beperken als je daar al vertegenwoordigers of distributeurs hebt, of als je producten niet voldoen aan de wetgeving inzake consumentenbescherming in die regio’s. Je kunt ook de verkoop in nieuwe regio’s activeren wanneer je klaar bent voor klanten in die gebieden."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "2++wCW",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt deze instellingen op elk moment wijzigen op het tabblad "
    }, {
      "children": [{
        "type": 0,
        "value": "Marktplaats"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " in je portaal onder "
    }, {
      "children": [{
        "type": 0,
        "value": "Winkelinstellingen"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": ". Hier kun je selecteren aan welke landen je wilt verkopen en locatiespecifieke bestelminima instellen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      LinkFormatting: function LinkFormatting(chunks) {
        return shopSettingLinkFormatting(chunks);
      }
    }
  })));
};
var shopSettingLinkFormatting = function shopSettingLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMyShopSettings(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};